import { get as getCookie } from "browser-cookies";

import { FeatureToggles } from "./featureToggles";

const featureTogglesKey = "featureToggles";

export const getFeatureToggles = (): FeatureToggles => {
    const featureTogglesCookie = getCookie(featureTogglesKey);

    const value = JSON.parse(featureTogglesCookie) as FeatureToggles || {};
    return value;
};
